import { booleanColumn } from '@/shared/grids/columns/booleanColumn';
import { dateColumn } from '@/shared/grids/columns/dateColumn';
import { idColumn } from '@/shared/grids/columns/idColumn';
import { textColumn } from '@/shared/grids/columns/textColumn';
import { MemberRole } from '@/shared/types/enum';
import { GridSettings } from '@/shared/types/grid';
import { enumOptions } from '@/shared/utils/enum';

import { MemberView } from '@prisma/client';

export const memberGrid: GridSettings<MemberView> = {
  defaultSort: {
    name: 'asc',
  },
  columns: [
    idColumn(),
    textColumn({
      header: 'Name',
      field: 'name',
    }),
    textColumn({
      header: 'Email',
      field: 'email',
    }),
    textColumn({
      header: 'Role',
      field: 'role',
      extra: {
        displayField: 'roleName',
        filter: {
          options: enumOptions(MemberRole),
        },
      },
    }),
    booleanColumn({
      header: '2FA',
      field: 'mfaEnabled',
      allowFiltering: false,
    }),
    dateColumn({
      header: 'Invited',
      field: 'createdTime',
      format: 'dayMonthYearTime',
      allowFiltering: false,
      visible: false,
    }),
    dateColumn({
      header: 'Last Seen',
      field: 'lastSeenTime',
      format: 'dayMonthYearTime',
      emptyText: 'Never',
      allowFiltering: false,
    }),
    dateColumn({
      header: 'Archived',
      field: 'archivedTime',
      visible: false,
    }),
  ],
};
